import React, { useEffect, useState } from "react";
import "../../Registration/MainRegister/mainRegister.css";
import { Link, useNavigate } from "react-router-dom";
import "../LoginWithMPIN/loginWithMPIN.css";
import axios from "../../../axios";

export default function LoginWithOTP() {
  const navigate = useNavigate();
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const [showGetOtp, setShowGetOtp] = useState(true);
  const [showResendOtp, setShowResendOtp] = useState(false);

  const School_ID = JSON.parse(localStorage.getItem("School_id"));
  const schoolCode = localStorage.getItem("schoolCode");
  const [timeDisplay, setTimeDisplay] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds, minutes]);

  const handleGetOtpClick = async () => {
    try {
      if (verify === "mobile") {
        // await axios.post("/api/v1/teacherAuth/generateMobileOtp", {
        //   mobile_number: contactNo,
        // });
      } else {
        await axios.post("/api/v1/teacherAuth/generateEmailOtp", {
          email_id: emailId,
        });
      }
      // setTimer(10); // Set timer to 60 seconds
      setShowGetOtp(false);
      setShowResendOtp(true); // Hide resend OTP button
      //Here increase otp time limit
      setMinutes(2);
      setSeconds(60);
      setTimeDisplay(true);
      setIsValidated("");
      setUserLogin({ Otp: "" });
    } catch (error) {
      // Handle the error appropriately (e.g., show an error message to the user)
      console.error("Error sending OTP:", error);
    }
  };

  const handleResendOtpClick = async () => {
    try {
      if (verify === "mobile") {
        {
          /* Here commented code is part of hide mobile OTP option */
        }
        // await axios.post("/api/v1/teacherAuth/generateMobileOtp", {
        //   mobile_number: contactNo,
        // });
      } else {
        await axios.post("/api/v1/teacherAuth/generateEmailOtp", {
          email_id: emailId,
        });
      }
      // setTimer(10);
      setShowGetOtp(false);
      setShowResendOtp(true);
      setMinutes(2);
      setSeconds(60);
      setUserLogin({ Otp: "" });
      setIsValidated("");
    } catch (error) {
      // Handle the error appropriately (e.g., show an error message to the user)
      console.error("Error resending OTP:", error);
    }
  };

  const [userLogin, setUserLogin] = useState({
    Otp: "",
  });
  //  this useEffect for remove invalid otp error when  otp time out error

  const [isVailidated, setIsValidated] = useState({});
  useEffect(() => {
    if (seconds === 0 && minutes === 0) {
      setIsValidated("");
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [seconds, minutes]);

  useEffect(() => {
    userLogin.Otp === "" && setIsValidated("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLogin.Otp]);

  // this function use for verify otp by api call

  const handleSubmit = async (e) => {
    e.preventDefault();
    let res;
    try {
      if (verify === "mobile") {
        // {/* Here commented code is part of hide mobile OTP option */}
        // res = await axios.post(`/api/v1/teacherAuth/loginwithMobileOtp`, {
        //   mobile_otp: userLogin.Otp,
        //   mobile_number: contactNo,
        //   user_id: School_ID,
        //   school_code: schoolCode,
        // });
        // res && navigate("/loginSuccess");
        // localStorage.setItem("Header", "Digital Class Management");
        //res && navigate("/DcmTimeTable");
        console.log("mobile api");
      } else {
        res = await axios.post(`/api/v1/teacherAuth/loginwithEmailOtp`, {
          email_otp: userLogin.Otp,
          email_id: emailId,
          user_id: School_ID,
          school_code: schoolCode,
        });
        //res2 && navigate("/DcmTimeTable");
        res && navigate("/loginSuccess");
        localStorage.setItem("Header", "Digital Class Management");
      }

      const Teacher_id = res.data.data.id;
      const emergencyNo = res.data.data.emergency_contact_number;
      const DOB = res.data.data.date_of_birth;
      const address = res.data.data.address;
      const gender = res.data.data.gender;
      const schoolId = res.data.data.school.id;
      localStorage.setItem("schoolId", JSON.stringify(schoolId));
      const timeTableSessionId = res.data.data.timetable_session.id;
      localStorage.setItem(
        "timeTableSessionId",
        JSON.stringify(timeTableSessionId),
      );
      const academicYearId = res.data.data.academic_year.id;
      if (academicYearId !== null && academicYearId !== undefined) {
        localStorage.setItem("academicYearId", JSON.stringify(academicYearId));
      } else {
        localStorage.setItem("academicYearId", JSON.stringify(""));
      }
      //Storing  Class Teacher Role_Information Array in Local Storage
      const role_as_class_teacher = res.data.data.role_as_class_teacher;
      const stringrole_as_class_teacher = JSON.stringify(role_as_class_teacher);
      localStorage.setItem(
        "role_as_class_teacher",
        stringrole_as_class_teacher,
      );
      //Storing Cordinator Role_INfo
      const role_as_co_ordinator = res.data.data.role_as_co_ordinator;
      const stringrole_as_co_ordinator = JSON.stringify(role_as_co_ordinator);
      localStorage.setItem("role_as_co_ordinator", stringrole_as_co_ordinator);
      //Storing general information in local storage
      const general_role = res.data.data.general_role;
      const stringgeneral_role = JSON.stringify(general_role);
      localStorage.setItem("general_role", stringgeneral_role);
      localStorage.setItem("Teacher_id", JSON.stringify(Teacher_id));
      localStorage.setItem(
        "emergency_contact_number",
        JSON.stringify(emergencyNo),
      );
      localStorage.setItem("date_of_birth", JSON.stringify(DOB));
      localStorage.setItem("address", JSON.stringify(address));
      localStorage.setItem("gender", JSON.stringify(gender));
    } catch (error) {
      setIsValidated(error.response.data);
    }
  };
  const uname = JSON.parse(localStorage.getItem("UserName"));
  const contactNo = JSON.parse(localStorage.getItem("Mobile_no"));
  const emailId = JSON.parse(localStorage.getItem("Email"));
  const [verify, setVerify] = useState("email");
  const formattedNumber =
    "+91 - " +
    contactNo.toString().replace(/(\d{4})(\d{4})(\d{2})/, "$1 $2 $3");

  return (
    <div className="TotalContainer d-md-flex">
      {/* <div className='MainContainer col-12 p-0   '> */}

      <div className="banner_box col-lg-3 col-md-5 col-12 m-0 p-0">
        <img
          className="banner_img "
          src="/Register-img/baner_img.jpg"
          alt="banner img"
        ></img>
      </div>

      <div className="form_box_loin col-lg-9 col-md-7  col-12 p-0 ">
        <form>
          <div>
            <div className="total_logo_regist">
              <img
                className="logo_registration"
                src="/Register-img/Register_logo.png"
                alt="register img"
              ></img>
            </div>
            <div className="title_regis">Welcome {uname}</div>
            <div className="login_mpin">Login with OTP</div>

            <div className="d-md-flex mt-2">
              {/* Here commented code for hide mobile OTP option */}
              {/* <div class="form-check mr-3">
                <input
                  onClick={(e) => {
                    setVerify("mobile");
                    setIsValidated("");
                    setSeconds(0);
                    setShowResendOtp(false);
                    setShowGetOtp(true);
                    setUserLogin({
                      ...userLogin,
                      Otp: "",
                    });
                  }}
                  autocomplete="off"
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="radioBtn_input"
                  checked={verify === "mobile"}
                />
                <label
                  class="form-check-label"
                  for="exampleRadios1"
                  className="radio_label"
                >
                  Mobile
                </label>
              </div> */}

              {/* <div class="form-check">
                <input
                  onClick={(e) => {
                    setVerify("email");
                    setIsValidated("");
                    setSeconds(0);
                    setShowResendOtp(false);
                    setShowGetOtp(true);
                    setUserLogin({
                      ...userLogin,
                      Otp: "",
                    });
                  }}
                  id="specifyColor"
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  checked={true}
                />
                <label
                  class="form-check-label"
                  for="exampleRadios1"
                  className="radio_label"
                >
                  Email
                </label>
              </div> */}
            </div>

            <div className="input_box_mobile">
              {verify === "mobile" ? (
                <div id="myId" className="school_id_mpin" type="number">
                  {" "}
                  {formattedNumber}{" "}
                </div>
              ) : (
                <div id="myId" className="school_id_mpin" type="email">
                  {" "}
                  {emailId}{" "}
                </div>
              )}
            </div>

            <div className="input_box2">
              {seconds === 0 ? (
                <input id="myId" placeholder="Enter OTP" disabled={true} />
              ) : (
                <input
                  type="tel"
                  id="myId"
                  maxLength={6}
                  onChange={(e) =>
                    setUserLogin({
                      ...userLogin,
                      Otp: e.target.value,
                    })
                  }
                  placeholder="Enter OTP"
                  value={userLogin.Otp}
                  autoComplete="off"
                />
              )}

              {timeDisplay && (
                <span className="Login_time_otp">
                  {minutes < 10 ? `0${minutes}` : minutes}:
                  {seconds < 10 ? `0${seconds}` : seconds}
                </span>
              )}
              {showGetOtp && (
                <p className="get_otp " onClick={handleGetOtpClick}>
                  Get OTP
                </p>
              )}
            </div>

            <div>
              {isVailidated.status === false && (
                <div className="invailidOtp">Invalid OTP entered</div>
              )}
              {seconds === 0 && minutes === 0 && showResendOtp === true && (
                <div className="invailidOtp">OTP Timed out</div>
              )}
            </div>

            <div>
              <button
                class="btn btn"
                id={
                  (!minutes && !seconds) ||
                  userLogin.Otp.length !== 6 ||
                  !userLogin.Otp
                    ? "btn_disabled"
                    : "main_login_btn"
                }
                type="submit"
                onClick={handleSubmit}
                disabled={
                  userLogin.Otp.length !== 6 ||
                  !userLogin.Otp ||
                  (seconds === 0 && minutes === 0)
                }
              >
                Login
              </button>
            </div>
            <div className="d-flex justify-content-center mt-3">
              <div id="Resend_verifyOtp">
                {/* //Here I added logic for enable continue button on time interval */}
                {showResendOtp && seconds === 0 && minutes === 0 && (
                  <p className="resendText" onClick={handleResendOtpClick}>
                    Resend OTP
                  </p>
                )}
              </div>
            </div>

            {!userLogin.Otp && showGetOtp && (
              <>
                <div className="or_line mt-3">Or</div>
                <div>
                  <Link to="/LoginWithPassWord">
                    <button
                      class="btn btn"
                      id="Login_with_pass_Btn"
                      type="button"
                    >
                      Login with Password
                    </button>
                  </Link>
                </div>
                <div>
                  <Link to="/LoginWithMpin">
                    {" "}
                    <button
                      class="btn btn"
                      id="Login_with_pass_Btn"
                      type="button"
                    >
                      Login with Pin
                    </button>
                  </Link>
                </div>
              </>
            )}
            <div className="total_already_login_otp">
              <span className="not_john">Not&nbsp;{uname} ?</span> &nbsp;
              <Link className="Link_register" to="/">
                <span className="login_diff_ccount">
                  Login with different account
                </span>
              </Link>
            </div>
          </div>
        </form>
      </div>

      {/* </div> */}
    </div>
  );
}
